module.exports = __webpack_public_path__ + "img/jianghaoyang.e26dcbe9.jpg";